// 制御ブロック（旧ビルダープレビュー blocks/controls.ts から復元）
// くりかえし（loop）と 色条件（if/while）。生成コードは util / scene / character を参照。
// ※旧実装にあった素の sleep/highlightBlock 参照は util. プレフィックスへ統一（ReferenceError 防止）。

import Blockly from "blockly";
import { customAlphabet } from "nanoid";
import BlocklyJs from "blockly/javascript";
import { appendRepeatTimesFields } from "common/blockly/fields";

export const InitControlsBlock = () => {
  Blockly.Blocks["controls_repeat_internal"] = {
    max_: 5,
    init: function () {
      const options = Array(this.max_)
        .fill(0)
        .map((value, index) => [`${index + 1}`, `${index + 1}`]);
      appendRepeatTimesFields(this.appendDummyInput("dummy_times"), options);
      this.appendStatementInput("DO");
      this.setInputsInline(true);
      this.setPreviousStatement(true);
      this.setNextStatement(true);
      this.setColour("#FFAB19");
      this.contextMenu = false;
    },
    saveExtraState: function () {
      return { max: this.max_ };
    },
    loadExtraState: function (state) {
      this.max_ = state["max"];
      const options = Array(this.max_)
        .fill(0)
        .map((value, index) => [`${index + 1}`, `${index + 1}`]);
      const dummyInput: Blockly.Input = this.getInput("dummy_times");
      dummyInput.removeField("before_label", true);
      dummyInput.removeField("TIMES", true);
      dummyInput.removeField("label", true);
      appendRepeatTimesFields(dummyInput, options);
    },
  };
  BlocklyJs["controls_repeat_internal"] = function (block: Blockly.Block) {
    const repeats = String(Number(block.getFieldValue("TIMES")));
    const logic = BlocklyJs.statementToCode(block, "DO");
    const varName = customAlphabet("abcdef", 6)();
    return `
    await util.sleep(100);
    for (var ${varName} = 0; ${varName} <  ${repeats}; ${varName}++){
      util.highlightBlock("${block.id}", true);
      await util.sleep(100);
      util.highlightBlock("${block.id}", false);
      ${logic}
    };`;
  };

  const controlsWhileUntilColourBlock = () => ({
    type: "controls_whileUntil_colour_internal",
    message0: "%{BKY_COURSE_WHILE_UNTIL}",
    args0: [{ type: "input_value", name: "COLOUR", check: "Colour" }],
    message1: "%1",
    args1: [{ type: "input_statement", name: "DO" }],
    previousStatement: null,
    nextStatement: null,
  });
  Blockly.Blocks["controls_whileUntil_colour_internal"] = {
    init: function () {
      this.jsonInit(controlsWhileUntilColourBlock());
      this.setColour("#FFAB19");
      this.contextMenu = false;
    },
  };
  BlocklyJs["controls_whileUntil_colour_internal"] = function (block: Blockly.Block) {
    let colour = BlocklyJs.valueToCode(
      block,
      "COLOUR",
      (BlocklyJs as unknown as { ORDER_ADDITION: number }).ORDER_ADDITION,
    );
    if (!colour) {
      colour = `""`;
    }
    const logic = BlocklyJs.statementToCode(block, "DO");
    if (logic === "") {
      return `util.highlightBlock("${block.id}", true);`;
    }
    return `
      await util.sleep(100);
      while(!scene.isDisposed && (util.action.checkBtnColor(scene, character) !== ${colour})){
        if(--window.LoopTrap < 1) {
          if (scene && !scene.isDisposed) { scene.dispose(); }
          util.setSuccess(false);
          util.setGameOver(true);
          return;
        };
        util.highlightBlock("${block.id}", true);
        await util.sleep(100);
        util.highlightBlock("${block.id}", false);
        ${logic}
        await util.sleep(100);
      };`;
  };

  const controlsIfColourBlock = () => ({
    type: "controls_if_colour_internal",
    message0: "%{BKY_COURSE_IF_COLOUR}",
    args0: [{ type: "input_value", name: "COLOUR", check: "Colour" }],
    message1: "%1",
    args1: [{ type: "input_statement", name: "DO" }],
    previousStatement: null,
    nextStatement: null,
  });
  Blockly.Blocks["controls_if_colour_internal"] = {
    init: function () {
      this.jsonInit(controlsIfColourBlock());
      this.setColour("#FFAB19");
      this.contextMenu = false;
    },
  };
  BlocklyJs["controls_if_colour_internal"] = function (block: Blockly.Block) {
    let colour = BlocklyJs.valueToCode(
      block,
      "COLOUR",
      (BlocklyJs as unknown as { ORDER_ADDITION: number }).ORDER_ADDITION,
    );
    if (!colour) {
      colour = `""`;
    }
    const logic = BlocklyJs.statementToCode(block, "DO");
    if (logic === "") {
      return `util.highlightBlock("${block.id}", true);`;
    }
    return `
      await util.sleep(100);
      util.highlightBlock("${block.id}", true);
      await util.sleep(100);
      if(!scene.isDisposed && (util.action.checkBtnColor(scene, character) === ${colour})){
        util.highlightBlock("${block.id}", false);
        ${logic}
      } else {
        util.highlightBlock("${block.id}", false);
      };`;
  };
};
